module.exports = __webpack_public_path__ + "media/images/features/draft/icon-faq-answer-7f2f9c77a1e0936c9a5a5d4152826d0a.svg";